// Keep catalog copy brief; the tool's full description remains on its detail page.
const SUMMARIES = {
  'youtube-summarizer': 'Get the key ideas from any YouTube video.',
  'blog-writer': 'Turn an idea into a complete first draft.',
  'code-generator': 'Turn a task into code you can build on.',
  'image-generator': 'Bring an image you imagine to life.',
  'video-generator': 'Turn your idea into a short film.',
  'music-generator': 'Create an original soundtrack.',
  'logo-generator': 'Give your brand a visual identity.',
  'svg-generator': 'Create crisp, scalable graphics.',
  'text-to-3d': 'Turn a description into a 3D model.',
  'image-to-3d': 'Give a reference image another dimension.',
  'object-remover': 'Remove distractions from your photos.',
  'image-editor': 'Describe a change. Transform your image.',
  'translator': 'Find the right words in another language.',
  'text-to-speech': 'Give your words a voice.',
  'model-comparison': 'Compare answers from different models.',
  'research-assistant': 'Explore a topic and organize your findings.',
  'content-detector': 'Look for signs of AI-generated writing.',
  'fact-checker': 'Check a claim against its sources.',
  'powerpoint-generator': 'Turn your ideas into a presentation.',
  'image-upscaler': 'Make your images sharper and larger.',
  'transcription': 'Turn recordings into readable transcripts.',
  'email-writer': 'Write the email you have in mind.',
  'linkedin-post-generator': 'Shape your idea for your social feed.',
  'social-media-kit': 'Create a coordinated set of social posts.',
  'product-description': 'Make your product’s best features clear.',
  'resume-writer': 'Tell your professional story with clarity.',
  'text-humanizer': 'Make your draft sound more natural.',
  'image-to-text': 'Read text and details from an image.',
  'url-analyzer': 'Understand what’s on a webpage.',
  'sql-generator': 'Turn your data question into a SQL query.',
  'regex-builder': 'Build a pattern that finds what you need.',
  'api-builder': 'Build a request for your API.',
  'app-builder': 'Give your app idea a practical starting point.',
  'meeting-notes': 'Find the decisions and next steps.',
  'data-analyzer': 'Find meaning in your numbers.',
  'document-reviewer': 'Find the details that deserve a closer look.',
  'presentation-outline': 'Give your presentation a clear story.',
  'interior-design': 'Picture a new look for your space.',
  'photo-studio': 'Create a polished portrait or product shot.',
  'clothes-changer': 'Try a different look in your photo.',
  'image-vectorizer': 'Turn your image into a scalable graphic.',
  'talking-photo': 'Bring a portrait to life with speech.',
  'business-card-generator': 'Create a business card worth keeping.',
  'church-announcement-writer': 'Keep your congregation informed.',
  'church-newsletter-writer': 'Bring your church’s news together.',
  'ministry-event-planner': 'Plan your next gathering with care.',
  'church-volunteer-coordinator': 'Organize the people who make it happen.',
  'ministry-outreach-planner': 'Plan meaningful ways to serve your community.',
  'church-donor-stewardship-writer': 'Thank supporters and share your impact.',
  'small-group-discussion-guide': 'Start a thoughtful conversation around Scripture.',
  'church-policy-drafter': 'Put your church’s guidelines into words.',
  'lipsync-generator': 'Match your character’s lips to your audio.',
};

const TONES = {
  create: ['#795CAE', '#C0A8EB', '#F0ECF8', '#2E263D'],
  edit: ['#AA5F68', '#E7A5AF', '#FAEDEF', '#3A262C'],
  write: ['#986D2D', '#DEBB7E', '#F7F0E3', '#352E23'],
  analyze: ['#326CA8', '#92BCEB', '#EAF1F9', '#202D3D'],
  code: ['#5263AA', '#A6B5F0', '#ECEEF9', '#272E45'],
  'church-ministry': ['#986D2D', '#DEBB7E', '#F7F0E3', '#352E23'],
  business: ['#98704A', '#DCC0A1', '#F5EFE8', '#342E28'],
};

export function getToolPresentation(tool, dark = false) {
  const name = (tool?.name || '').replace(/^AI\s+/, '');
  const tone = TONES[tool?.category?.slug] || TONES.analyze;
  let summary = SUMMARIES[tool?.slug];
  if (!summary && name.startsWith('Chat with ')) summary = 'A focused space for your next conversation.';
  if (!summary && /^Generate (Images|Videos) Using /.test(name)) summary = tool.outputType === 'video'
    ? 'Bring your scene to life with this model.' : 'Create an image with this model.';
  if (!summary && /^Edit Images with /.test(name)) summary = 'Transform an image with this model.';
  if (!summary) {
    const description = (tool?.shortDescription || tool?.description || '').trim();
    summary = description.length > 105 ? `${description.slice(0, 102).replace(/\s+\S*$/, '')}…` : description;
  }
  return { name, summary, foreground: tone[dark ? 1 : 0], background: tone[dark ? 3 : 2] };
}
